export interface ISeverity {
    none?: boolean;
    medium?: boolean;
    severe?: boolean;
    low?: boolean;
    high?: boolean;
}

export interface ISourceType {
    rule?: boolean;
    correlation?: boolean;
    extension?: boolean;
    reputation?: boolean;
    av?: boolean;
    ransomware?: boolean;
}

export interface ISignal {
    alert?: boolean;
    nonAlert?: boolean;
}

export interface IInstantNotificationSettings {
    subject: string;
    severity: ISeverity;
    sourceType: ISourceType;
    signal: ISignal;
}

export interface INotificationSchedule {
    expression?: string;
    useLocalTimezone: boolean;
    frequency?: string;
}

export enum NotificationType {
    ALERT_DIGEST = 'alert-digest',
    ALERT_INSTANT = 'alert-instant'
}

export interface IScheduleOptions {
    frequency?: string;
    time: string;
    days?: string[];
    weekdays?: string[];
    expression?: string;
    schedule?: string;
    notificationType?: NotificationType;
    timezone?: string;
}
